import React, { createContext, useState, useContext, useEffect } from 'react';
import { useAuth } from './AuthContext';

interface Config {
    doctorName?: string;
    companyInfo?: string;
    footerAddress?: string;
    logoUrl?: string;
    logoCartaUrl?: string;
    logoRecipeUrl?: string;
    font?: string;
    fontSize?: number;
}

interface ConfigContextType {
    config: Config | null;
    loadConfig: () => Promise<void>;
    isLoading: boolean;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

const API_URL = process.env.REACT_APP_API_URL || 'https://luiatro-health-cloud-production.up.railway.app';

export const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
    const [config, setConfig] = useState<Config | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const { user } = useAuth();

    const loadConfig = async () => {
        if (!user) {
            setConfig(null);
            setIsLoading(false);
            return;
        }

        try {
            const token = localStorage.getItem('token');
            
            const response = await fetch(`${API_URL}/api/config`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log('✅ [CONFIG-CONTEXT] Configuración cargada:', data);
                setConfig(data);
            }
        } catch (error) {
            console.error('❌ [CONFIG-CONTEXT] Error cargando config:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Cargar config cuando el usuario inicia sesión
    useEffect(() => {
        loadConfig();
    }, [user]);

    return (
        <ConfigContext.Provider value={{ config, loadConfig, isLoading }}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('useConfig debe usarse dentro de ConfigProvider');
    }
    return context;
};